// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"ir_a bie_tr","LeftMenu__link":"ir_b bie_vt bie_a bie_rc","LeftMenu__link__icon":"ir_c"};